// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/font.eot?gxcbg6", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/font.ttf?gxcbg6", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/font.woff?gxcbg6", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/font.svg?gxcbg6", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#font" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'icon-font';
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="icon-"], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icon-font', sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-sheet:before {
  content: "\\e900";
}
.icon-download:before {
  content: "\\e901";
}
.icon-image:before {
  content: "\\e902";
}
.icon-imagesmode:before {
  content: "\\e903";
}
.icon-trending_down:before {
  content: "\\e904";
}
.icon-trending_flat:before {
  content: "\\e905";
}
.icon-trending_up:before {
  content: "\\e906";
}
`, "",{"version":3,"sources":["webpack://./assets/css/font.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,6CAAkC;EAClC;;;yDAGiD;EACjD,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,+CAA+C;EAC/C,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'icon-font';\n  src:  url('fonts/font.eot?gxcbg6');\n  src:  url('fonts/font.eot?gxcbg6#iefix') format('embedded-opentype'),\n    url('fonts/font.ttf?gxcbg6') format('truetype'),\n    url('fonts/font.woff?gxcbg6') format('woff'),\n    url('fonts/font.svg?gxcbg6#font') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icon-font', sans-serif !important;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-sheet:before {\n  content: \"\\e900\";\n}\n.icon-download:before {\n  content: \"\\e901\";\n}\n.icon-image:before {\n  content: \"\\e902\";\n}\n.icon-imagesmode:before {\n  content: \"\\e903\";\n}\n.icon-trending_down:before {\n  content: \"\\e904\";\n}\n.icon-trending_flat:before {\n  content: \"\\e905\";\n}\n.icon-trending_up:before {\n  content: \"\\e906\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
